import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';

const useStyles = makeStyles()((theme) => ({
  listItemIcon: {
    minWidth: theme.spacing(4),
  },
}));

type ChatMessagesMenuProps = {
  onClickEdit: () => void;
  anchorEl: null | HTMLElement;
  onClose: () => void;
};

const ChatMessagesMenu = ({ onClickEdit, anchorEl, onClose }: ChatMessagesMenuProps) => {
  const { classes } = useStyles();
  const { translate } = useTranslation();

  const handleOnClickEdit = () => {
    onClickEdit();
    onClose();
  };

  return (
    <Menu
      id="chat-more-actions-menu"
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <MenuItem onClick={handleOnClickEdit}>
        <ListItemIcon className={classes.listItemIcon}>
          <EditRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={translate(LangEnum.CHAT_MESSAGES_MENU_EDIT_ROOM)} />
      </MenuItem>
    </Menu>
  );
};

export default memo(ChatMessagesMenu);
